import { HeadlineSchemeDefinition } from "./headline-types";
import { BackgroundColor } from "../../background/constants/background-types";
import * as AllColors from "../../../constants/colors";
import { createHeadlineMapDefinition } from "../../../utils/scheme-helper";
import { toConstantCase } from "../../../utils/string-format";

function createSchemes() {
  let newSchemes: AllColors.HeadlineSchemeConfiguration<HeadlineSchemeDefinition> = {};

  AllColors.HEADLINE_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      color: AllColors[`COLOR_${toConstantCase(element.schemeName)}`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });

  return newSchemes;
}

export const HEADLINE_SCHEME_CONFIG: AllColors.HeadlineSchemeConfiguration<HeadlineSchemeDefinition> = createSchemes();

export const HEADLINE_SCHEME_MAP: Map<BackgroundColor | "default", HeadlineSchemeDefinition> = new Map(
  Object.entries(createHeadlineMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    HEADLINE_SCHEME_CONFIG[config as string]
  ])
);

export const HEADLINE_SIZE_H1 = "h1";
export const HEADLINE_SIZE_H2 = "h2";
export const HEADLINE_SIZE_H3 = "h3";
export const HEADLINE_SIZE_H4 = "h4";
export const HEADLINE_SIZE_H5 = "h5";
export const HEADLINE_SIZE_H6 = "h6";
export const HEADLINE_SIZE_COPY = "copy";
export const HEADLINE_SIZES = [
  HEADLINE_SIZE_H1,
  HEADLINE_SIZE_H2,
  HEADLINE_SIZE_H3,
  HEADLINE_SIZE_H4,
  HEADLINE_SIZE_H5,
  HEADLINE_SIZE_H6,
  HEADLINE_SIZE_COPY
] as const;

export const HEADLINE_TAG_H1 = "h1";
export const HEADLINE_TAG_H2 = "h2";
export const HEADLINE_TAG_H3 = "h3";
export const HEADLINE_TAG_H4 = "h4";
export const HEADLINE_TAG_H5 = "h5";
export const HEADLINE_TAG_H6 = "h6";
export const HEADLINE_TAGS = [
  HEADLINE_TAG_H1,
  HEADLINE_TAG_H2,
  HEADLINE_TAG_H3,
  HEADLINE_TAG_H4,
  HEADLINE_TAG_H5,
  HEADLINE_TAG_H6
] as const;
